export enum ListAccess {
  PRIVATE = 'private',
  PUBLIC = 'public',
}
